export default __webpack_public_path__ + "static/media/avatar7.40edb864.png";